import { FETCH_LOGIN, FAILED_LOGIN, RECEIVE_LOGIN, FETCH_LOGOUT, RECEIVE_LOGOUT, FETCH_CHECK_AUTH, RECEIVE_CHECK_AUTH } from '../actions/users/aActions-userLogin.jsx';
import cookie from 'react-cookies'

const defaultAuthState = {
    authData: []    
}
var newAuthState;

export function fetchAuth(state = defaultAuthState, action) {
    switch (action.type) {
        case FETCH_LOGIN: 
            return ({
                authData: null,
                inProgress: true,
                isAuthenticated: false
            });
        case RECEIVE_LOGIN:
            newAuthState = action.payload;
            console.log(!action.payload.division_leader)
            cookie.save('token', newAuthState[0].token, {path: '/'})
            cookie.save('role',newAuthState[0].roles_name, {path: '/'})
            cookie.save('division_id', newAuthState[0].division_id, {path: '/'})
            cookie.save('userlevel_roles', newAuthState[0].userlevel_roles, {path: '/'}) //Jenis role (sys admin, super admin, admin, etc)
            cookie.save('userlevel_id', newAuthState[0].userlevel_id, {path: '/'})
            cookie.save('userID', newAuthState[0].id, {path: '/'})
            cookie.save('organizationID', newAuthState[0].organization_id, {path: '/'})
            cookie.save('divisionName', newAuthState[0].division_name, {path: '/'})
            cookie.save('isAuthenticated', true, {path: '/'})
              if(newAuthState[0].userlevel_roles >= 0){
                cookie.save('division_id', newAuthState[0].division_id,{path: '/'})
                cookie.save('organizationID', newAuthState[0].organization_id,{path: '/'})
                cookie.save('divisionName', newAuthState[0].division_name, {path: '/'})
            } else {
                cookie.save('division_id', 0, {path: '/'})
                cookie.save('organizationID', 0, {path: '/'})
                cookie.save('divisionName', 'Semua divisi', {path: '/'})
            }
            return Object.assign(
                {},
                state,
                newAuthState,
                {
                    authData: newAuthState, 
                    inProgress: false,
                    isAuthenticated: true
                }
            );
        case FAILED_LOGIN: 
            return ({
                authData: null,
                inProgress: false,
                isAuthenticated: false
            });
        case FETCH_LOGOUT: 
            return ({
                ...state,
                inProgress: true
            })
        case RECEIVE_LOGOUT:
            newAuthState = null
            return ({
                authData: null,
                inProgress: false,
                isAuthenticated: false
            })
        case FETCH_CHECK_AUTH:
            return ({
                ...state,
                inProgress: true,
                isAuthenticated: false
            })
        case RECEIVE_CHECK_AUTH:
            // console.log(newAuthState);
            if(newAuthState === '[]') {
                return ({
                    authData: null,
                    inProgress: false,
                    isAuthenticated: true
                })
            } else if(newAuthState == null) {
                return({
                    ...state,
                    inProgress: false,
                    isAuthenticated: false
                });
            } else if(newAuthState != null) {
                return({
                    ...state,
                    inProgress: false,
                    isAuthenticated: true
                });
            } else {
                return({
                    ...state, 
                    inProgress: false,
                    isAuthenticated: true
                });
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/redAuth-LoginReducers.jsx